import React from 'react'
import { Size } from '../../types/size'

type SearchIconProps = {
    size: Size
}

const SearchIcon = ({ size }: SearchIconProps) => (
    <svg width={size.width} height={size.height} viewBox="0 0 36 34" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <filter x="-0.9%" y="-14.0%" width="101.8%" height="128.1%" filterUnits="objectBoundingBox" id="filter-1">
                <feMerge>
                    <feMergeNode in="SourceGraphic"></feMergeNode>
                </feMerge>
            </filter>
            <path
                d="M20.9128252,0.604545455 C27.8965197,0.604545455 33.5447862,6.35733396 33.5447862,13.4378788 C33.5447862,20.5184236 27.8965197,26.2712121 20.9128252,26.2712121 C18.1300211,26.2712121 15.5592559,25.3577865 13.4733991,23.8109034 L4.95515648,32.901072 C4.29431575,33.6063439 3.18686261,33.6423626 2.48159067,32.9815218 C1.8178053,32.3595541 1.74685334,31.3419712 2.29175009,30.6364179 L2.40114082,30.507956 L10.9732796,21.3585654 C9.28630644,19.1762475 8.2808642,16.4252394 8.2808642,13.4378788 C8.2808642,6.35733396 13.9291307,0.604545455 20.9128252,0.604545455 Z M20.9128252,4.10454545 C15.8766375,4.10454545 11.7808642,8.27611167 11.7808642,13.4378788 C11.7808642,18.5996459 15.8766375,22.7712121 20.9128252,22.7712121 C25.9490129,22.7712121 30.0447862,18.5996459 30.0447862,13.4378788 C30.0447862,8.27611167 25.9490129,4.10454545 20.9128252,4.10454545 Z"
                id="path-2"
            ></path>
        </defs>
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="FAQ" transform="translate(-1126.000000, -272.000000)">
                <g id="Contents" transform="translate(269.000000, 201.000000)">
                    <g id="search" filter="url(#filter-1)" transform="translate(0.000000, 60.000000)">
                        <g id="search-button" transform="translate(845.000000, 0.000000)">
                            <g id="icons/search" transform="translate(12.000000, 11.000000)">
                                <mask id="mask-3" fill="white">
                                    <use xlinkHref="#path-2"></use>
                                </mask>
                                <use id="Mask" fill="#FFFFFF" fillRule="nonzero" xlinkHref="#path-2"></use>
                                <g id="colors/gradients/_master" mask="url(#mask-3)">
                                    <g transform="translate(0.291667, 0.291667)" id="colors/gradients/white">
                                        <g></g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

SearchIcon.defaultProps = {
    size: {
        width: 36,
        height: 36,
    },
}

export default SearchIcon
